import axios from "axios";

export default () => {
  return axios.create({
    baseURL:
      process.env.NODE_ENV === "production"
        ? `${process.env.VUE_APP_JTI_CMT_COMPUTED_TRANSACTION_SERVICE}/${process.env.VUE_APP_JTI_CMT_COMPUTED_PROXY}`
        : `${process.env.VUE_APP_JTI_CMT_COMPUTED_TRANSACTION_SERVICE}:${process.env.VUE_APP_JTI_CMT_COMPUTED_TRANSACTION_PORT}`,
    headers: {
      "Content-Type": `application/json`,
      Authorization: `Bearer ${process.env.VUE_APP_JTI_CMT_COMPUTED_TRANSACTION_TOKEN}`,
    },
  });
};
